<template>

    <div class="center">
      <div class="centerCS">
        <el-carousel indicator-position="outside">
          <el-carousel-item v-for="(img,index) in imgList" :key="index">
            <img v-bind:src="img.url">
          </el-carousel-item>
        </el-carousel>
        <div class="clear ul_list">
          <div class="leftList">
            <p class="clear">
              <span class="span_left">行业动态</span>
              <router-link to="/Industry" class="span_right">更多></router-link>
            </p>
            <ul>
              <li>
                <router-link to="/part">第十届合肥地区公办高职院校关工委工作年会在安徽交通...</router-link>
              </li>
              <li>
                <router-link to="/part">中国交通教育研究会职业教育分会 2019年理事长办...</router-link>
              </li>
              <li>
                <router-link to="/part">中国交通教育研究会认定中心成立大会 暨智能技术研讨...</router-link>
              </li>
              <li>
                <router-link to="/part">中国交通教育研究会交通职业能力研究中心工作座谈会在...</router-link>
              </li>
              <li>
                <router-link to="/part">中国交通教育研究会 关于成立交通职业能力认定中心的...</router-link>
              </li>
              <li>
                <router-link to="/part">关于开展2018-2020年度中国交通教育 终身成...</router-link>
              </li>
              <li>
                <router-link to="/part">青海交通运输职业教育集团2018年工作年会顺利召开...</router-link>
              </li>
              <li>
                <router-link to="/part">中国交通教育研究会标准化技术委员会2018年会在山...</router-link>
              </li>
            </ul>
          </div>
          <div class="leftList">
            <p class="clear">
              <span class="span_left">标准规范</span>
              <router-link to="/standard" class="span_right">更多></router-link>
            </p>
            <ul>
              <li>
                <router-link to="/part">关于召开2019年中国交通教育研究会标准...</router-link>
              </li>
              <li>
                <router-link to="/part">关于表彰中国交通教育终身成就奖、 中国交...</router-link>
              </li>
              <li>
                <router-link to="/part">关于组建电动汽车产、教、研创新联盟专家委...</router-link>
              </li>
              <li>
                <router-link to="/part">关于举办交通运输系统实验室安全管理 高级...</router-link>
              </li>
              <li>
                <router-link to="/part">关于召开中国交通教育研究会2019年年会...</router-link>
              </li>
              <li>
                <router-link to="/part">关于开展2018-2020年度中国交通教育 终身成...</router-link>
              </li>
              <li>
                <router-link to="/part">中国交通教育研究会职业教育分会 2019...</router-link>
              </li>
              <li>
                <router-link to="/part">中国交通教育研究会认定中心成立大会 暨智...</router-link>
              </li>
            </ul>
          </div>
          <div class="rightBtn">
            <router-link to="/Inquire" class="btn1">证书查询</router-link>
            <div data-v-5ba5e354="" class="btn1 noAllow">考点查询</div>
            <div data-v-5ba5e354="" class="btn1 noAllow">申请考点</div>
            <div data-v-5ba5e354="" class="btn1 noAllow">考试系统</div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>


export default {
  name: 'HomeView',
  data(){
    return{
      imgList:[
        {url:require('../assets/1.7716a5b.jpg')},
        {url:require('../assets/2.29e173e.jpg')},
        {url:require('../assets/3.511c00b.jpg')},
        {url:require('../assets/4.ae34d49.jpg')}
      ]
    }
  }
}
</script>

<style>
.ul_list{
  width: 1000px;
  margin-top: 25px;
  height: 300px;
}
.leftList{
  float: left;
  width: 360px;
  height: 100%;
  background: #fff;
  margin-right: 20px;
}
.leftList p{
  padding: 0 20px;
  height: 44px;
  border-bottom: 1px solid #9cc4e2;
}
.span_left{
  display: block;
  float: left;
  line-height: 44px;
  font-size: 14px;
  color: #0068b6;
  font-weight: bolder;
}
.span_right{
  display: block;
  float: right;
  line-height: 44px;
  font-size: 14px;
  color: #9cc4e2;
  text-decoration: none;
}
.leftList ul{
  padding: 0 20px;
  height: 240px;
  margin-top: 10px;
}
.leftList ul li{
  height: 30px;
  list-style: none;
}
.leftList ul li a{
  display: block;
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 13px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: none;
  color: #666;
}
.rightBtn{
  width: 240px;
  height: 100%;
  float: right;
}
.btn1{
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  display: block;
  background: #9cc4e2;
  color: #fff;
  text-align: center;
  margin-bottom: 20px;
}
a{
  text-decoration: none;
}
.noAllow{
  cursor: not-allowed;
}
</style>
